<div *ngIf="data">
  <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 10px">
    <div class="col-sm-11 movable">
      <h3 class="head" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
        <strong>{{ data.mode | uppercase }} MODULE TYPE</strong>
      </h3>
    </div>
    <div class="col-sm-1">
      <button type="button" class="btn btn-dark btn-circle btn-xl" [mat-dialog-close]="true" data-dismiss="modal"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <form [formGroup]="addOrEditform">
    <div class="row my-1">
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">UNLOAD AREA</label>
          <p-dropdown id="unload_area" [options]="filteredUnloadAreaList" [filter]="true" [virtualScroll]="true"
            [itemSize]="30" optionLabel="unload_area" placeholder="Select" formControlName="unload_area"
            [style]="{ width: '100%', height: '25px' }" scrollHeight="100px" [appendTo]="'body'" [autoWidth]="false"
            filterBy="unload_area" (onChange)="unloadAreaChange()"></p-dropdown>
          <ng-container *ngIf="addOrEdit.unload_area.errors && submitted">
            <small *ngIf="addOrEdit.unload_area.errors?.required">
              Unload Area is required.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">MODULE TYPE</label>
          <p-dropdown id="module_type" [options]="filteredModuleTypeList" [filter]="true" [virtualScroll]="true"
            [itemSize]="30" optionLabel="module_type" placeholder="Select" formControlName="module_type"
            [style]="{ width: '100%', height: '25px' }" scrollHeight="100px" [appendTo]="'body'" [autoWidth]="false"
            filterBy="module_type" (onChange)="moduleTypeChange()"></p-dropdown>
          <ng-container *ngIf="addOrEdit.module_type.errors && submitted">
            <small *ngIf="addOrEdit.module_type.errors?.required">
              Module Type is required.
            </small>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="row my-1">
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">MODULE DESCRIPTION</label>
          <input type="text" class="form-control desc" placeholder="Enter" formControlName="module_desc"
            maxlength="100" />
          <ng-container *ngIf="addOrEdit.module_desc.errors && submitted">
            <small *ngIf="addOrEdit.module_desc.errors?.required">
              Module Description is required.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">LINE</label>
          <p-multiSelect id="line" formControlName="line" [options]="filteredLineList" optionLabel="line" filterBy="line"
            [showToggleAll]="false" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [defaultLabel]="'--Select--'"
            [virtualScroll]="true" [itemSize]="25" autoWidth="false" [style]="{ width: '100%' }" [resetFilterOnHide]="true"
            [appendTo]="'body'" panelStyleClass="mt2-ms-panel" (onChange)="onLineGroupChange('line')"></p-multiSelect>
          <ng-container>
            <small *ngIf="isLine">
              Line is required.
            </small>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="row my-1">
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">ID LINE</label>
          <p-multiSelect id="id_line" formControlName="id_line" [options]="filteredIdLineList" optionLabel="id_line"
            filterBy="id_line" [showToggleAll]="false" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
            [defaultLabel]="'--Select--'" [virtualScroll]="true" [itemSize]="25" autoWidth="false" [style]="{ width: '100%' }"
            [resetFilterOnHide]="true" [appendTo]="'body'" panelStyleClass="mt2-ms-panel"
            (onChange)="onLineGroupChange('id_line')"></p-multiSelect>
          <ng-container *ngIf="addOrEdit.id_line.errors && submitted">
            <small *ngIf="addOrEdit.id_line.errors?.required">
              ID Line is required.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">OSP LINEPATH</label>
          <p-multiSelect id="linePathList" formControlName="linePathList" [options]="filteredLinePathList"
            optionLabel="osp_line_path" dataKey="osp_line_path" optionDisabled="disabled" filterBy="osp_line_path" [showToggleAll]="false" [showTransitionOptions]="'0ms'"
            [hideTransitionOptions]="'0ms'" [defaultLabel]="'--Select--'" [virtualScroll]="true" [itemSize]="25" autoWidth="false"
            [style]="{ width: '100%' }" [resetFilterOnHide]="true" [appendTo]="'body'"
            panelStyleClass="mt2-ms-panel" (onChange)="onLineGroupChange('linePathList')"></p-multiSelect>
          <ng-container>
            <small *ngIf="isLinePath">
              Osp Line Path is required.
            </small>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="row my-1">
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">MODEL NAME</label>
          <p-multiSelect id="model_name" formControlName="model_name" [options]="filteredModelNameList" optionLabel="model_name"
            filterBy="model_name" [showToggleAll]="false" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
            [defaultLabel]="'--Select--'" [virtualScroll]="true" [itemSize]="25" autoWidth="false" [style]="{ width: '100%' }"
            [resetFilterOnHide]="true" [appendTo]="'body'" panelStyleClass="mt2-ms-panel"></p-multiSelect>
          <ng-container *ngIf="addOrEdit.model_name.errors && submitted">
            <small *ngIf="addOrEdit.model_name.errors?.required">
              Model Name is required.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">TRACKING POINT</label>
          <p-dropdown id="trackingPoint" [options]="filteredTrackingPointList" [filter]="true" [virtualScroll]="true"
            [itemSize]="1" optionLabel="tracking_point" placeholder="Select" formControlName="tracking_point"
            [style]="{ width: '100%', height: '25px' }" scrollHeight="100px" [appendTo]="'body'" [autoWidth]="false"
            filterBy="tracking_point" (onFilter)="onFilterTrackingPoint($event)"></p-dropdown>
          <ng-container *ngIf="addOrEdit.tracking_point.errors && submitted">
            <small *ngIf="addOrEdit.tracking_point.errors?.required">
              Tracking Point is required.
            </small>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="row my-1">
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">DOCKS</label>
          <p-multiSelect id="dock" formControlName="dock" [options]="newDockList" optionLabel="dock" filterBy="dock"
            [showToggleAll]="false" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [defaultLabel]="'--Select--'"
            [virtualScroll]="true" [itemSize]="25" autoWidth="false" [style]="{ width: '100%' }" [resetFilterOnHide]="true"
            [appendTo]="'body'" panelStyleClass="mt2-ms-panel"></p-multiSelect>
          <ng-container *ngIf="addOrEdit.dock.errors && submitted">
            <small *ngIf="addOrEdit.dock.errors?.required">
              Dock is required.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">TYPE OF MODULE</label>
          <div class="radio-row">
            <label class="radio-opt">
              <input type="radio" formControlName="type_of_module" value="controlling" />
              <span>Controlling</span>
            </label>
            <label class="radio-opt">
              <input type="radio" formControlName="type_of_module" value="independent" />
              <span>Independent</span>
            </label>
          </div>
          <ng-container *ngIf="addOrEdit.type_of_module.errors && submitted">
            <small *ngIf="addOrEdit.type_of_module.errors?.required">
              Type Of Module is required.
            </small>
          </ng-container>
        </div>
      </div>
    </div>
  </form>

  <div class="text-right" style="margin-top: 20px">
    <button class="review_btn" mat-button (click)="callRespectiveFunction()">
      Save
    </button>

    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
</div>